import { useState } from 'react'
import { TransactionHistory } from '../components/rewards/transaction-history'
import { AddBonusPoints } from '../components/rewards/add-bonus-points'

interface BonusPointTransaction {
  id: string
  firstName: string
  lastName: string
  email: string
  employeeEntrataEmail?: string
  points: number
  description: string
  rewardedBy: string
  date: string
  department?: string
}

type TabType = 'add-bonus-points' | 'transaction-history'

const TABS = [
  { key: 'add-bonus-points' as TabType, label: 'Add Bonus Points' },
  { key: 'transaction-history' as TabType, label: 'Bonus Points Transaction History' },
]

const formatDate = () =>
  new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })

export function Rewards() {
  const [activeTab, setActiveTab] = useState<TabType>('add-bonus-points')
  const [transactions, setTransactions] = useState<BonusPointTransaction[]>([])

  const createTransaction = (data: Omit<BonusPointTransaction, 'id' | 'date'>) => ({
    ...data,
    id: Date.now().toString(),
    date: formatDate(),
  })

  const addTransaction = (transactionData: Omit<BonusPointTransaction, 'id' | 'date'>) => {
    setTransactions([createTransaction(transactionData), ...transactions])
  }

  const addBulkTransactions = (newTransactions: Omit<BonusPointTransaction, 'id' | 'date'>[]) => {
    const bulkTransactions = newTransactions.map((transaction, index) => ({
      ...transaction,
      id: (Date.now() + index).toString(),
      date: formatDate(),
    }))
    setTransactions([...bulkTransactions, ...transactions])
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case 'add-bonus-points':
        return (
          <AddBonusPoints
            onAddTransaction={addTransaction}
            onAddBulkTransactions={addBulkTransactions}
            onNavigateToHistory={() => setActiveTab('transaction-history')}
          />
        )
      case 'transaction-history':
        return <TransactionHistory transactions={transactions} />
      default:
        return null
    }
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h1>Rewards Configuration</h1>
            <p className="text-muted-foreground">Manage your Homebody Rewards Program</p>
          </div>
        </div>
      </div>

      <div className="border-b border-border mb-6">
        <div className="flex -mb-px text-[14px]">
          {TABS.map(tab => (
            <button
              key={tab.key}
              className={`py-2 px-4 mr-2 font-medium ${
                activeTab === tab.key
                  ? 'border-b-2 border-[#000000] text-foreground'
                  : 'text-muted-foreground'
              }`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {renderTabContent()}
    </div>
  )
}
